var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row form-page-detail--body" },
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "div",
          { staticClass: "section-container" },
          [
            _c("h6", { staticClass: "font-weight-bold" }, [
              _vm._v("General Information")
            ]),
            _vm._v(" "),
            _c(
              "b-form-group",
              { class: { "error-input": _vm.$v.dataSetup.name.$error } },
              [
                _c("label", [_vm._v(" AI Model Name ")]),
                _vm._v(" "),
                _c("j-input", {
                  model: {
                    value: _vm.$v.dataSetup.name.$model,
                    callback: function($$v) {
                      _vm.$set(_vm.$v.dataSetup.name, "$model", $$v)
                    },
                    expression: "$v.dataSetup.name.$model"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("label", [_vm._v(" AI Purpose ")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "container-type-list-options",
                staticStyle: { "justify-content": "left" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "container-option text-align-center",
                    class:
                      _vm.typeMode === "classification" ? "option-active" : "",
                    on: {
                      click: function($event) {
                        _vm.typeMode = "classification"
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "text-option" }, [
                      _vm._v("Classification")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "container-option text-align-center",
                    class: _vm.typeMode === "regression" ? "option-active" : "",
                    on: {
                      click: function($event) {
                        _vm.typeMode = "regression"
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "text-option" }, [
                      _vm._v("Regression")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "container-option text-align-center",
                    class: _vm.typeMode === "clustering" ? "option-active" : "",
                    on: {
                      click: function($event) {
                        _vm.typeMode = "clustering"
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "text-option" }, [
                      _vm._v("Clustering")
                    ])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              [
                _c("label", [_vm._v(" Dataset ")]),
                _vm._v(" "),
                _c("j-input", {
                  attrs: { disabled: true },
                  model: {
                    value: _vm.formData.name,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "name", $$v)
                    },
                    expression: "formData.name"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "section-container" },
          [
            _c("h6", { staticClass: "font-weight-bold" }, [_vm._v("Provider")]),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                class: {
                  "error-input": _vm.$v.dataSetup.connection_name.$error
                }
              },
              [
                _c("label", [_vm._v("Third Party")]),
                _vm._v(" "),
                _c("j-single-select", {
                  attrs: {
                    options: _vm.listThirdParty,
                    placeholder: "Select Third Party",
                    label: "label"
                  },
                  model: {
                    value: _vm.$v.dataSetup.connection_name.$model,
                    callback: function($$v) {
                      _vm.$set(_vm.$v.dataSetup.connection_name, "$model", $$v)
                    },
                    expression: "$v.dataSetup.connection_name.$model"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "section-container" },
          [
            _c("h6", { staticClass: "font-weight-bold" }, [
              _vm._v("Target Class")
            ]),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                class: { "error-input": _vm.$v.dataSetup.target_class.$error }
              },
              [
                _c("label", [_vm._v("Column")]),
                _vm._v(" "),
                _c("j-single-select", {
                  attrs: {
                    options: _vm.listTargetClass,
                    placeholder: "Select Column",
                    label: "label"
                  },
                  model: {
                    value: _vm.$v.dataSetup.target_class.$model,
                    callback: function($$v) {
                      _vm.$set(_vm.$v.dataSetup.target_class, "$model", $$v)
                    },
                    expression: "$v.dataSetup.target_class.$model"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3de098b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3de098b8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ai/menu/jMenuInfo.vue
// module id = null
// module chunks = 